import Plugin from 'src/plugin-system/plugin.class';

export default class CustomNavPillsPlugin extends Plugin {

    init() {
        $(this.el).find('.custom-nav-pills-widget__previous').on('click', () => {

            if (!$(this.el).find('.nav-link.active').parent().prev('li').find('a').length) {
                $(this.el).find('.nav-item:last-child a').tab('show');
                return null;
            }

            $(this.el).find('.nav-link.active').parent().prev('li').find('a').trigger('click');
        });

        $(this.el).find('.custom-nav-pills-widget__next').on('click', () => {

            if (!$(this.el).find('.nav-link.active').parent().next('li').find('a').length) {
                $(this.el).find('.nav-item:first-child a').tab('show');
                return null;
            }

            $(this.el).find('.nav-link.active').parent().next('li').find('a').trigger('click');
        });
    }

}
